"use strict";
/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MosaicAddressRestriction = void 0;

var catbuffer_typescript_1 = require("catbuffer-typescript");

var MosaicAddressRestriction = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param version
   * @param compositeHash
   * @param entryType
   * @param mosaicId
   * @param targetAddress
   * @param restrictions
   */
  function MosaicAddressRestriction(
  /**
   * Version
   */
  version,
  /**
   * composite hash
   */
  compositeHash,
  /**
   * Mosaic restriction entry type.
   */
  entryType,
  /**
   * Mosaic identifier.
   */
  mosaicId,
  /**
   * Target address
   */
  targetAddress,
  /**
   * Mosaic restriction items
   */
  restrictions) {
    _classCallCheck(this, MosaicAddressRestriction);

    this.version = version;
    this.compositeHash = compositeHash;
    this.entryType = entryType;
    this.mosaicId = mosaicId;
    this.targetAddress = targetAddress;
    this.restrictions = restrictions;
  }
  /**
   * Returns the restriction for a given key.
   *
   * @param key the key.
   */


  _createClass(MosaicAddressRestriction, [{
    key: "getRestriction",
    value: function getRestriction(key) {
      return this.restrictions.find(function (item) {
        return item.key.equals(key);
      });
    }
    /**
     * Generate buffer
     * @return {Uint8Array}
     */

  }, {
    key: "serialize",
    value: function serialize() {
      var mosaicId = this.mosaicId.toBuilder();
      var address = this.targetAddress.toBuilder();
      var keyPairs = new catbuffer_typescript_1.AddressKeyValueSetBuilder(this.restrictions.sort(function (a, b) {
        return a.key.compare(b.key);
      }).map(function (item) {
        var key = new catbuffer_typescript_1.MosaicRestrictionKeyDto(item.key.toDTO());
        var value = item.restrictionValue.toDTO();
        return new catbuffer_typescript_1.AddressKeyValueBuilder(key, value);
      }));
      var addressRestrictionBuilder = new catbuffer_typescript_1.MosaicAddressRestrictionEntryBuilder(mosaicId, address, keyPairs);
      return new catbuffer_typescript_1.MosaicRestrictionEntryBuilder(this.version, catbuffer_typescript_1.MosaicRestrictionEntryTypeDto.ADDRESS, addressRestrictionBuilder, undefined).serialize();
    }
  }]);

  return MosaicAddressRestriction;
}();

exports.MosaicAddressRestriction = MosaicAddressRestriction;